import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import useDynamicCmpPermission from "@/hooks/useDynamicCmpPermission";
import { PanelBoxV2 } from "@/tpo/Boxes";

import { CMP_PERMISSION_CHOOSE_PATIENT } from "../../constants";
import GetOrCreatePatient from "./GetOrCreatePatient";

export default function PatientSelection() {
  const { organisation } = useOrganisationContext();
  const { basket, updateBasketDetails, loading } = useOrganisationBasketContext();
  const canCreatePatient = useDynamicCmpPermission({
    permission: "can_create_patient"
  });

  const selectedPatient = basket?.patient; // platform user profile
  const selectedOrgPatient = organisation?.patients.find(
    p => p.patientProfile.pk === selectedPatient?.pk
  );

  const canChoosePatient = (organisation?.permissions || []).includes(
    CMP_PERMISSION_CHOOSE_PATIENT
  );

  const handleSelectedPatient = value => {
    if (!canChoosePatient || value === selectedOrgPatient?.id || !organisation) {
      return;
    }
    let pup = organisation.patients.find(p => p.id === value)?.patientProfile;
    updateBasketDetails({
      patient: pup?.pk ?? "",
      usePatientAddress: pup?.pk ? true : false
    });
  };

  return (
    <PanelBoxV2
      maxWidth={760}
      outer={{
        bg: "white",
        px: [20, 20, 40],
        pt: [20, 20, 40],
        pb: [50, 50, 80],
        borderRadius: 5
      }}
    >
      <GetOrCreatePatient
        canCreate={canCreatePatient}
        onSelect={handleSelectedPatient}
        selectedPatient={selectedOrgPatient}
        titleProps={{}}
        descriptionProps={{
          mt: 20
        }}
        selectPatientFieldProps={{
          mt: 30,
          disabled: loading || !canChoosePatient
        }}
        patientDetailsProps={{
          mt: 30
        }}
        buttonProps={{
          mt: 30,
          disabled: loading
        }}
      />
    </PanelBoxV2>
  );
}
